import { OptionDescription } from './option.type';
import { EPurpose } from '../enums/purpose.enum';

export type PurposeRecord = Record<EPurpose, OptionDescription<EPurpose>>;
